// singleton class for the lookup data http calls to the API

import { BaseService } from './base-service';
import { getHTTPHeaders } from '../helpers/utils';

class LookupDataService extends BaseService {
    constructor() {
        super();
    }

    getCompaniesList() {
        return new Promise((resolve, reject) => {
            this.$http.get('getCompaniesForSelect', getHTTPHeaders())
                .then((response) => {
                    resolve(response.data.companies);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getAreaList(companyId) {
        return new Promise((resolve, reject) => {
             this.$http.get('getAreasForSelect?company_id=' + companyId, getHTTPHeaders())
                .then((response) => {
                    resolve(response.data.areas);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getSiteList(areaId) {
        return new Promise((resolve, reject) => {
            this.$http.get('getSitesForSelect?area_id=' + areaId, getHTTPHeaders())
                .then((response) => {
                    resolve(response.data.sites);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getContactTitles() {
        return new Promise((resolve, reject) => {
            let headersObj = getHTTPHeaders();
            $http.get("getContactTitlesForSelect", headersObj)
                .then((response) => {
                    resolve(response.data.titles);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }
    
    getAddressCounties() {
        return new Promise((resolve, reject) => {
            let headersObj = getHTTPHeaders();
            $http.get("getCountiesForSelect", headersObj)
                .then((response) => {
                    resolve(response.data.counties);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }
    
    getAddressCountries() {
        return new Promise((resolve, reject) => {
            let headersObj = getHTTPHeaders();
            $http.get("getCountriesForSelect", headersObj)
                .then((response) => {
                    resolve(response.data.countries);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

}

export default new LookupDataService();